/**
 * FeedbackOption enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file FeedbackOption.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum FeedbackOption {
  HideUnequippable = 0,
  TutorialPopups = 1,
  Subtitles = 2,
  MiniMap = 3,
  FloatingNumbers = 4,
  StatusSummary = 5,
  HideQuickMenuButtons = 6,
  EnableToolTips = 7,
}